/**
 * Model representing a master profile
 */
export class PerfilMaster {
  constructor(
    public readonly codPerfil: number,
    public readonly dscPerfil: string,
    public readonly codPerfilGerador: number
  ) {}

  static fromJson(json: any): PerfilMaster {
    return new PerfilMaster(
      json.codPerfil || 0,
      json.dscPerfil || '',
      json.codPerfilGerador || 0
    );
  }

  toJson(): any {
    return {
      codPerfil: this.codPerfil,
      dscPerfil: this.dscPerfil,
      codPerfilGerador: this.codPerfilGerador,
    };
  }
}

